import { useCallback } from 'react'

import { useUserFeedbackMutation } from '@/__generated/es-api'
import { createNotification } from '@/app/module/notifications/store/actions'
import { useAppDispatch } from '@/app/store/redux-hooks'

type FeedbackData = {
  subject?: string
  message: string
}

export const useSendFeedback = () => {
  const dispatch = useAppDispatch()
  const [sendFeedbackMutation, mutationResult] = useUserFeedbackMutation()

  const sendFeedback = useCallback(
    async (data: FeedbackData) => {
      try {
        await sendFeedbackMutation({
          body: {
            message: data.message,
          },
        }).unwrap()

        dispatch(
          createNotification({
            'feedback-success': {
              type: 'success',
              message: 'Thank you for your feedback! We appreciate your input.',
            },
          }),
        )

        return true
      } catch {
        dispatch(
          createNotification({
            'feedback-error': {
              type: 'error',
              message:
                "Oops, that didn't work. Please try again or message us in the Customer Service chat (bottom right corner).",
            },
          }),
        )
        return false
      }
    },
    [dispatch, sendFeedbackMutation],
  )

  return [sendFeedback, mutationResult] as const
}
